export const GET_FLAGGED_SITES = 'GET_FLAGGED_SITES'
export const GET_FLAGGED_SITES_FULFILLED = 'GET_FLAGGED_SITES_FULFILLED'
export const GET_FLAGGED_SITES_COUNT = 'GET_FLAGGED_SITES_COUNT'
export const POST_FLAGGED_STATUS = 'POST_FLAGGED_STATUS'
export const POST_FLAGGED_STATUS_PENDING = 'POST_FLAGGED_STATUS_PENDING'
export const POST_FLAGGED_STATUS_FULFILLED = 'POST_FLAGGED_STATUS_FULFILLED'
export const GET_FLAGGED_ACCOUNTS = 'GET_FLAGGED_ACCOUNTS'
export const GET_FLAGGED_ACCOUNTS_FULFILLED = 'GET_FLAGGED_ACCOUNTS_FULFILLED'
export const GET_FLAGGED_ACCOUNTS_COUNT = 'GET_FLAGGED_ACCOUNTS_COUNT'
export const CLEAR_FLAGGED = 'CLEAR_FLAGGED'

export const GET_SUSPICIOUS_WORD_TYPES = 'GET_SUSPICIOUS_WORD_TYPES'
export const GET_SUSPICIOUS_WORDS = 'GET_SUSPICIOUS_WORDS'
export const ADD_SUSPICIOUS_WORD = 'ADD_SUSPICIOUS_WORD'
export const RESET_POST_RESPONSE = 'RESET_POST_RESPONSE'
export const DELETE_SUSPICIOUS_WORD = 'DELETE_SUSPICIOUS_WORD'
export const DELETE_SUSPICIOUS_WORD_PENDING = 'DELETE_SUSPICIOUS_WORD_PENDING'
export const DELETE_SUSPICIOUS_WORD_FULFILLED = 'DELETE_SUSPICIOUS_WORD_FULFILLED'
export const DELETE_SUSPICIOUS_WORD_ERROR = 'DELETE_SUSPICIOUS_WORD_ERROR'
export const RESET_DELETE_RESPONSE = 'RESET_DELETE_RESPONSE'

export const POST_SEARCH_FRAUD_PREVENTION_LOGS = 'POST_SEARCH_FRAUD_PREVENTION_LOGS'

export const GET_SANCTIONS_LIST = 'GET_SANCTIONS_LIST'
export const POST_SDN_CHANGE = 'POST_SDN_CHANGE'

export const POST_SANCTIONS_UPDATE_STATUS = 'POST_SANCTIONS_UPDATE_STATUS'

export const GET_ADULT_THRESHOLD = 'GET_ADULT_THRESHOLD'
export const POST_ADULT_THRESHOLD = 'POST_ADULT_THRESHOLD'
export const POST_ADULT_THRESHOLD_PENDING = 'POST_ADULT_THRESHOLD_PENDING'
export const POST_ADULT_THRESHOLD_FULFILLED = 'POST_ADULT_THRESHOLD_FULFILLED'
export const RESET_ADULT_THRESHOLD = 'RESET_ADULT_THRESHOLD'

export const GET_PUBLISHED_SITES_THRESHOLD = 'GET_PUBLISHED_SITES_THRESHOLD'
export const POST_PUBLISHED_SITES_THRESHOLD = 'POST_PUBLISHED_SITES_THRESHOLD'
export const POST_PUBLISHED_SITES_THRESHOLD_PENDING = 'POST_PUBLISHED_SITES_THRESHOLD_PENDING'
export const POST_PUBLISHED_SITES_THRESHOLD_FULFILLED = 'POST_PUBLISHED_SITES_THRESHOLD_FULFILLED'
export const RESET_PUBLISHED_SITES_THRESHOLD = 'RESET_PUBLISHED_SITES_THRESHOLD'
